import { Component, Input, ViewChild } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BeanDialogDimension, BeanKendoDialogService, WindowContainerDimension, WindowVisualizerDirective } from 'bean-kendo-dialog';
import { DetailGpsDialogComponent } from '../detail-gps-dialog/detail-gps-dialog.component';
import { DumpsterService } from '@veritas-dumpsters/services/dumpster.service';
import { Dumpster } from '@veritas-shared/models/dumpster';
import { ParametersCommand } from '@veritas-dumpsters/models/dumpster-gps-info';
import { tap } from 'rxjs/operators';
import { ToastService } from '@veritas-shared/services/toast.service';

@Component({
  selector: 'app-location-field',
  templateUrl: './location-field.component.html',
  styleUrls: ['./location-field.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class LocationFieldComponent {
  @ViewChild(WindowVisualizerDirective, { static: true })
  public windowVisualizer: WindowVisualizerDirective;

  @Input() public dumpster?: Dumpster;
  
  constructor(
    private translate: TranslateService,
    private dialogService: BeanKendoDialogService,
    private dumpsterService: DumpsterService,
    private toastService: ToastService,
  ) { }

  public setNewModal = (dumpster: Dumpster) => {
    if (!dumpster) return;
    this.dialogService.openDialog(
      `${this.translate.instant('$lbl.forceGpsLocationTitle')} [${dumpster?.code}]`,
      dumpster,
      DetailGpsDialogComponent,
      this.windowVisualizer,
      (action) => { },
      (command: ParametersCommand<string>) => this._setForcePosition(dumpster, command),
      true,
      WindowContainerDimension.Medium,
      { mediumHeight: 800, mediumWidth: 1500 } as BeanDialogDimension
    );
  }

  private _setForcePosition = (
    dumpster: Dumpster, command: ParametersCommand<string>
  ) => this.dumpsterService.putForcePosition<string>(dumpster?.supplierName, dumpster?.code, command).pipe(
    tap(() => this.toastService.showSuccess(this.translate.instant('$lbl.ForceGpsSuccess'))),
  );
}
